import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import TopBarActions from './TopBarActions';
import TopBar from '../../Home/TopBar';
import { useUserContext } from '../../../context/UserContext';
import { useSearchParams } from '../../../context/SearchParamsContext';
import { useHistory, useParams } from 'react-router-dom';
import qs from 'qs';
import PropertyInformation from './PropertyInformation';
import AssessmentInformation from './AssessmentInformation';
import { NjPropertyLookup, Property, PropertyMatch, Result } from '../types';
import axios from 'axios';
import OwnershipInformation from './OwnershipInformation';
import StreetViewMap from './StreetViewMap';
import TaxMap from './TaxMap';
import { Loader } from 'semantic-ui-react';
import { trimEnd } from '../../../components/utilities/functions';

const PropertyInfo = () => {
  const { user } = useUserContext();
  const searchParams = useSearchParams();
  const history = useHistory();
  const [property, setProperty] = useState<Result>();
  const { propertyId, location } = useParams<{ propertyId: string; location: string }>();
  const headerSearch = () => {
    const queryString = qs.stringify({
      open: searchParams.isTopSearchOpen ? 1 : 0,
      query: searchParams.topSearchText,
    });
    document.title = '';
    history.push(`/home?${queryString}`);
  };

  const closeDetailsSearch = () => {
    searchParams.setTopSearchText('');
    searchParams.setIsTopSearchOpen(false);
  };

  const getPropertyInfo = async () => {
    const queryOptions = {
      rpadId: propertyId,
    };
    const stringifiedParams = qs.stringify(queryOptions);
    const baseUrl = `/api/clientproperty/validateRpad/${location}`;
    const { data } = await axios.get<PropertyMatch>(`${baseUrl}?${stringifiedParams}`);
    const property = data.results[0];
    axios.post(`/api/clientProperty/UploadPropertyData`, {
      clientId: user.clientId,
      address: property.address,
      section: property.property.section,
      block: property.property.block,
      lot: property.property.lot,
      qualifier: property.property.qualifier,
      municipalityId: property.muniTypes[1].id,
      subMunicipalityId: property.muniTypes[2]?.id,
      propertyResultJson: JSON.stringify(property),
    });
    if (data.totalCount > 1) {
      //handle this
    } else {
      const description = await getBuildingClassByCode(property.property.propertyClass);
      if (property.muniTypes[0].stateCode === 'NJ') {
        const data = await getPropertyLookupInfoNj(property);
        property.zipCode = data?.result?.countyData?.P_Zip;
      }
      setProperty({ ...property, buildingDescription: description });
    }
  };
  const getBuildingClassByCode = async (buildingCode: string) => {
    if (!buildingCode) {
      return null;
    }
    const route = `/api/clientproperty/GetBuildingTypeByCode?buildingType=${buildingCode}`;
    const { data } = await axios.get(route);
    return data;
  };
  const getPropertyLookupInfoNj = async (property: Result) => {
    const swisCode = property.muniTypes[1].swisCode;
    const block = trimEnd(property.property.block, '.');
    const lot = trimEnd(property.property.lot, '.');
    const qualifier = property.property.qualifier ? `_${property.property.qualifier}` : '';
    const { data } = await axios.get<NjPropertyLookup>(
      `https://njpropertyrecords.com/api/property/${swisCode}_${block}_${lot}${qualifier}?apiKey=988bb1e33286f80887ae3042689cc2f6`
    );
    return data;
  };
  useEffect(() => {
    getPropertyInfo();
  }, []);
  if (!property) {
    return <Loader active />;
  }

  return (
    <div>
      <TopBar
        search={headerSearch}
        searchText={searchParams.topSearchText}
        onSearchTextChange={searchParams.setTopSearchText}
        setSearchOpen={searchParams.setIsTopSearchOpen}
        searchOpen={searchParams.isTopSearchOpen}
        info
        name={user.clientName}
        closeSearch={closeDetailsSearch}
      />
      <div style={{ margin: '50px auto', maxWidth: 1400, paddingBottom: 50 }}>
        <TopBarActions property={property} />
        <div style={{ display: 'flex' }}>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <PropertyInformation property={property} />
            <OwnershipInformation property={property} />
            <AssessmentInformation property={property} />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <StreetViewMap property={property} />
            <TaxMap
              property={property}
              location={location}
              county={property?.muniTypes[0].name}
              swisCode={property?.muniTypes[2]?.swisCode || property?.muniTypes[1]?.swisCode}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropertyInfo;
